import { GET_NAVIGATION } from './action-types'
import { SET_NAVIGATION } from './mutation-types'

export default {
	async [GET_NAVIGATION] ({ commit }, router) {

		if (!router) {
			console.warn('Router not available in GET_NAVIGATION action')
			return
		}

		try {
			const navigation = createNavigationFromRoutes(router.options.routes)
			commit(SET_NAVIGATION, [...navigation])
		} catch (error) {
			console.error('Error creating navigation:', error)
			commit(SET_NAVIGATION, [])
		}
	}
}

function createNavigationFromRoutes (globalRoutes) {
	let routes = [].concat(globalRoutes)
	routes.forEach(route => {
		if (route.children) {
			routes.push(...createNavigationFromRoutes(route.children))
		}
	})
	return routes.filter(route => {
		return route.meta && route.meta.displayInSidebar && route.meta.displayName
	})
}
